<template>
    <div>
        <p class="card-text text-bold text-center" v-if="pool.length < max_participants">Create participation pool consting of <b>{{ min_participants }} - {{ max_participants }}</b> participants</p>
        <p class="card-text text-center" v-if="pool.length >= max_participants">Your participation pool consists of the following participants:</p>
        <div class="participants-pool row justify-content-center"  v-if="pool.length > 0">
            <template v-for="(participant, index) in pool">
                <div class="participant-pill col-3 mt-3 mx-1 pl-4" :key="index">
                    <h6>{{ participant.name }} <br> <small>{{ participant.email }}</small> <br> <small>{{ participant.phone }}</small> </h6>
                    <n-button class="mt-3" type="danger" size="sm" round icon simple @click.native="deleteInput(participant)">
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                    </n-button>
                </div>
            </template>
        </div>
        <div class="cf-creator row" v-if="pool.length < max_participants">
            <div class="col-sm-3">
                <fg-input
                    :required="true"
                    type="text"
                    name="name"
                    label="name"
                    v-validate="modelValidations.name"
                    :error="getError('name')"
                    v-model="model.name">
                </fg-input>
            </div>
            <div class="col-sm-3">
                <fg-input
                    :required="true"
                    type="email"
                    name="email"
                    label="email"
                    v-validate="modelValidations.email"
                    :error="getError('email')"
                    v-model="model.email">
                </fg-input>
            </div>
            <div class="col-sm-3">
                <fg-input
                    :required="true"
                    type="text"
                    name="phone"
                    label="phone"
                    v-validate="modelValidations.phone"
                    :error="getError('phone')"
                    v-model="model.phone">
                </fg-input>
            </div>
            <div class="col-sm-3 pt-2">
                <n-button @click.native="addToPool()" type="primary" round simple block> <i class="now-ui-icons ui-1_simple-add"></i> Add to Pool</n-button>
            </div>
            <div class="col-sm-12 text-center text-danger text-sm" v-if="errorMsg">{{ errorMsg }}</div>
            <div class="col-sm-12 text-center text-info text-sm" v-if="infoMsg">{{ infoMsg }}</div>
        </div>
    </div>
</template>

<script>

import { FormGroupInput, Card, Button, Switch  } from 'src/components';
import { Select, Option, Tag } from 'element-ui';

export default {
    name: 'PoolForm',
    components: {
        [Button.name]: Button,
        [FormGroupInput.name]: FormGroupInput,
    },
    props: {
        min_participants: Number,
        max_participants: Number
    },
    data(){
        return {
            pool: [],
            model: {
                name: null,
                email: null,
                phone: null,
            },
            modelValidations: {
                name:{ required: true },
                email:{ required: true, email: true },
                phone:{ required: true, length:10, numeric: true  },
            },
            errorMsg: '',
            infoMsg: ''
        }
    },
    methods: {
        copyInput(input){
            this.model = Object.assign({}, input)
        },
        deleteInput(input){
            this.pool.splice(this.pool.indexOf(input), 1)
            this.$emit('on-pool', Object.assign([], this.pool))
        },
        addToPool(){
            return this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if((this.pool.length + 1) <= this.max_participants){
                        // check for unique emails && phone among participants
                        let duplicate = this.pool.some( value => { return  (value.email == this.model.email || value.phone == this.model.phone  ) } );
                        if(!duplicate){
                            this.pool.push(this.model)
                            this.model = {
                                name: null,
                                email: null,
                                phone: null,
                            }
                            this.errorMsg = ''
                            this.infoMsg = ''
                            this.errors.clear()
                            this.$nextTick(() => {
                                this.$validator.reset()
                            })
                            this.$emit('on-pool', Object.assign([], this.pool))
                        }
                        else{
                            this.errorMsg = `Please use unique 'email' and 'phone' values for participants`;
                        }
                    }
                }
                return isValid
            });
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        }
    }
}
</script>

<style lang="scss">

.participants-pool{
    padding: 10px;

    .participant-pill{
        display: flex;
        border-radius: 50px;
        border: solid 1px #eee;
        box-shadow: 0px 0px 5px #eee;
        
        h6{
            margin-top: 5px;
            width: 90%;

            small{
                text-transform: lowercase;
            }
        }
        .btn{
            width: 10%;
            margin: 0;
            margin-top: 7px;
        }
    }
}


.cf-creator{
    margin-top: 15px;
    padding: 10px;
    box-shadow: 0px -10px 10px #eeeded;
}


.cf-creator,
.cf-container {
    .form-group label{
        margin-bottom: 0px;
        margin-left: 10px;
    }

    .input-new-tag{
        padding: 10px;
    }
}

.cf-creator .form-control-sm,
.cf-container .form-control-sm {
    height: calc(1.8125rem + 2px);
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
}
.cf-creator {
    .form-control.input-new-tag{
        width: 250px!important;
        text-align: center;
        display: inline-block;
    }
}


</style>
